import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/sample",
    name: "Sample",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "sample" */ "../views/Sample.vue"),
  },
  {
    path: "/upload-audio",
    name: "UploadAudio",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "sample" */ "../views/UploadAudio.vue"),
  },
  {
    path: "/upload-video",
    name: "UploadVideo",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "sample" */ "../views/UploadVideo.vue"),
  },
  {
    path: "/login",
    name: "Login",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "sample" */ "../views/Login.vue"),
  },
  {
    path: "/creators",
    name: "CreatorsLanding",
    component: () =>
      import(/* webpackChunkName: "creators" */ "../views/CreatorsLanding.vue"),
  },
  {
    path: "/teachers",
    name: "TeachersLanding",
    component: () =>
      import(/* webpackChunkName: "teachers" */ "../views/TeachersLanding.vue"),
  },
  {
    path: "/fun",
    name: "TeensLanding",
    component: () =>
      import(/* webpackChunkName: "fun" */ "../views/TeensLanding.vue"),
  },
  {
    path: "/podcasters",
    name: "LandingPodcasters",
    component: () =>
      import(
        /* webpackChunkName: "landing-podcasters" */ "../views/LandingPodcasters.vue"
      ),
  },
  {
    path: "/streamers",
    name: "LandingStreamers",
    component: () =>
      import(
        /* webpackChunkName: "landing-streamers" */ "../views/LandingStreamers.vue"
      ),
  },
  {
    path: "/musicians",
    name: "LandingMusicians",
    component: () =>
      import(
        /* webpackChunkName: "landing-musicians" */ "../views/LandingMusicians.vue"
      ),
  },
  {
    path: "/parents",
    name: "LandingParents",
    component: () =>
      import(
        /* webpackChunkName: "landing-parents" */ "../views/LandingParents.vue"
      ),
  },
  {
    path: "/camps",
    name: "LandingCamps",
    component: () =>
      import(/* webpackChunkName: "landing-camps" */ "../views/LandingCamps.vue"),
  },
  {
    path: "/comedians",
    name: "LandingComedians",
    component: () =>
      import(
        /* webpackChunkName: "landing-comedians" */ "../views/LandingComedians.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  routes,
});

export default router;
